var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccesslevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Access_kevel",
    "data-name": "Access kevel",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.67,
    height: 27.269,
    viewBox: "0 0 17.67 27.269",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31390",
    "data-name": "Rectangle 31390",
    width: 17.67,
    height: 27.269,
    fill: "#3c3c3b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12313",
    "data-name": "Group 12313",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38151",
    "data-name": "Path 38151",
    d: "M0,11.3v7.983c0,4.409,3.956,7.984,8.835,7.984s8.835-3.575,8.835-7.984V11.3Zm9.406,7v2.876H8.264V18.3a1.57,1.57,0,1,1,1.142,0m6.411-7.952H14.186V7.017a5.351,5.351,0,1,0-10.7,0v3.327H1.853V7.017a6.982,6.982,0,1,1,13.963,0Z",
    transform: "translate(0 0)",
    fill: "#3c3c3b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccesslevel);
export default __webpack_public_path__ + "static/media/Access level.ce6e1fd5595652c4986f9926da0a9d34.svg";
export { ForwardRef as ReactComponent };